import { getCookie } from "app/assets/javascripts/tracking/base-tracker"

export default function logEvent(name, options) {
  if (typeof window.amplitude === "undefined") return

  const globalOptions = {
    browserId: getCookie("browser_id"),
  }
  const updatedOptions = Object.assign({}, options, globalOptions)

  window.amplitude.getInstance().logEvent(name, updatedOptions)
}
